import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventLiveness } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
type LivenessEventHeaderProps = {
  data: UserTimelineEventLiveness['data'];
};
const LivenessEventHeader = t0 => {
  const $ = _c(6);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.livenessEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    source
  } = data;
  let t2;
  if ($[1] !== source || $[2] !== t) {
    t2 = source === "skipped" ? t(_temp) : t(_temp2);
    $[1] = source;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <p className="text-label-2" data-testid="liveness-event-header">{t2}</p>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default LivenessEventHeader;
function _temp($) {
  return $.skippedTitle;
}
function _temp2($_0) {
  return $_0.successTitle;
}